import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';

import Shipment from '@/resources/components/cart/shipment/Shipment';

import CartContent from './CartContent';

interface CheckoutPageProps {
  shipmentCardStyle: React.CSSProperties;
  showCartDeliveryAlert: boolean;
  order: any;
  min_order_amount: number;
  combos: any[];
  setEditProducts: (products: any) => void;
  setProductToCombo: (productToCombo: any) => void;
  setShipmentStep: (step: 1 | 2 | 3 | 4) => void;
  handleFinishOrder: () => boolean;
  setShowSendOrderAlert: (show: boolean) => void;
}

const CheckoutPage: React.FC<CheckoutPageProps> = ({
  shipmentCardStyle,
  showCartDeliveryAlert,
  order,
  min_order_amount,
  combos,
  setEditProducts,
  setProductToCombo,
  setShipmentStep,
  handleFinishOrder,
  setShowSendOrderAlert,
}) => {
  useEffect(() => {
    window.location.href = '#checkout-page';
  }, []);

  return (
    <div className="checkout-page row justify-content-center" id="checkout-page">
      <Col xs={12} md={8}>
        <CartContent
          shipmentCardStyle={shipmentCardStyle}
          showCartDeliveryAlert={showCartDeliveryAlert}
          order={order}
          min_order_amount={min_order_amount}
          combos={combos}
          setEditProducts={setEditProducts}
          setProductToCombo={setProductToCombo}
          hideQuantityInput={true}
        />
      </Col>

      <Col xs={12} md={4}>
        <Shipment
          order={order}
          setShipmentStep={setShipmentStep}
          handleFinishOrder={handleFinishOrder}
          forwardedOrderAlert={setShowSendOrderAlert}
          showPayment={true}
        />
      </Col>
      <div className="d-flex flex-md-row flex-column"></div>
    </div>
  );
};

export default CheckoutPage;
